import React from 'react';

const StaticTextType = ({text, textHtml}) => (
    textHtml ? <div dangerouslySetInnerHTML={{__html: textHtml}} className="richtext-container" /> : <div>{text}</div>
);

export default StaticTextType;
